import coreStore from '@/stores/core';

import { ALL_BOT_TYPE, INTENT_HOT_QUESTION_DISPLAY_TYPE } from '../constants';
import { HQ_UI_OPTIMISATION_GROUP } from './getHqUIOptimisation';

const MINIMISE_CATEGORY_GROUPS = ['other_frequently_asked', 'smaller_tab'];

export const isMinimiseCategoryGeneralEntryPoint = (hotQuestionDisplayType: INTENT_HOT_QUESTION_DISPLAY_TYPE) => {
  const initStore = coreStore.safeGetStore('initStore');
  const isBuyerBot = initStore?.botType === ALL_BOT_TYPE.INTENT_BASE_BOT;

  const isChangeQuestionsOrViewMore = [
    INTENT_HOT_QUESTION_DISPLAY_TYPE.GROUP1,
    INTENT_HOT_QUESTION_DISPLAY_TYPE.GROUP2,
  ].includes(hotQuestionDisplayType);
  const newABTestingConfigs = coreStore.safeGetStore('userStore').newABTestingConfigs || {};
  const { hq_ui_optimisation, minimise_category_general_entry_point } = newABTestingConfigs;
  const isEdd = hq_ui_optimisation === HQ_UI_OPTIMISATION_GROUP.EDD;

  return (
    isBuyerBot
    && isChangeQuestionsOrViewMore
    && isEdd
    && MINIMISE_CATEGORY_GROUPS.includes(minimise_category_general_entry_point)
  );
};

export const isMinimiseCategoryOrderSpecificEntryPoint = () => {
  const initStore = coreStore.safeGetStore('initStore');
  const isBuyerBot = initStore?.botType === ALL_BOT_TYPE.INTENT_BASE_BOT;

  const newABTestingConfigs = coreStore.safeGetStore('userStore').newABTestingConfigs || {};
  const { hq_ui_optimisation, minimise_category_order_specific_entry_point } = newABTestingConfigs;
  const isEdd = hq_ui_optimisation === HQ_UI_OPTIMISATION_GROUP.EDD;

  return isBuyerBot && isEdd && MINIMISE_CATEGORY_GROUPS.includes(minimise_category_order_specific_entry_point);
};
